export function handleSpecialHtml (container, link) {
  traverse(container)
}

function traverse (dom) {
  if (!dom.childNodes || dom.childNodes.length == 0) {
    if (dom.nodeType == 3) {
      dom.data = dom.data.replace(/_-_<_-_/gi, '<')
      dom.data = dom.data.replace(/_-_>_-_/gi, '>')
    }
    return
  }
  Array.from(dom.childNodes).forEach(child => {
    traverse(child)
  });
}